import { useState } from "react";
import { useInterval } from "../useInterval";

let i = 0;
export function usePollFetchKey(interval: number | null, fetchKey?: string) {
  const [key, setKey] = useState(i);
  useInterval(() => setKey(i++), interval);
  return (fetchKey ?? "") + key;
}
